import { Injectable } from '@angular/core';
import { TEMA_PORTAL_ATUAL, TemaPortal } from './tema-portal.model';

/**
 * Guarda o tema de cor publicado no portal.
 *
 * Quem grava é o bloco "Padrão de Cores e Ordenação", que lê o tema do órgão na API e o
 * deposita aqui; quem lê são as prévias do Cabeçalho, do Rodapé, do Banner, dos Destaques
 * e das Redes Sociais. `atual()` é síncrono porque essas prévias leem o tema uma vez, ao
 * montar: devolve o último tema depositado e cai no padrão do sistema enquanto a tela do
 * padrão não foi aberta na sessão ou quando o órgão ainda não escolheu tema.
 */
@Injectable({ providedIn: 'root' })
export class TemaPortalService {
  private tema: TemaPortal = TEMA_PORTAL_ATUAL;

  atual(): TemaPortal {
    return this.tema;
  }

  definir(tema: TemaPortal): void {
    this.tema = tema;
  }
}
